import React, {PropTypes} from 'react';
import { connect } from 'react-redux'
// LOCAL
// import ShowClientContainer from './ShowClientContainer'
import MainContentShowClient from './MainContentShowClient'
import {getClient, sendDataExport} from './actions'
import onMount from '../core/onMount'

const mapDispatchToProps = (dispatch, ownProps) => {
  const tokenId = ownProps.match.params.token_id
  return {
    dispatch, // needed for onMount HOC
    // TODO shared
    // handleSendReport: (data)=> dispatch(sendDataExportEnterprise(tokenId, data)),
    // onDateChange: (selectedDates)=> dispatch({type:"SELECT_DATES", selectedDates}),
    // getEnterpriseMember: (selectedDates)=> dispatch(getEnterpriseMember(tokenId, selectedDates)),
    handleSendReport: (data)=> dispatch(sendDataExport(tokenId, data)),
    // TODO easier way to pass?
    onDateChange: (selectedDates)=> {
      dispatch({type:"SELECT_DATES", selectedDates})
      dispatch(getClient(tokenId, selectedDates))
    },

  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.models.user,
    ui: state.ui,
    params: ownProps.match,
    userProfile: state.accountants.selectedClient
  }
}

const MountedMainContentShowClient = onMount(({dispatch, match}) => {
  dispatch(getClient(match.params.token_id))
})(MainContentShowClient)

export default connect(mapStateToProps, mapDispatchToProps)(MountedMainContentShowClient)



// WEBPACK FOOTER //
// ./src/accountants/ShowClientPage.js